module.exports = __webpack_public_path__ + "img/ticket-print-template.4bb4f872.png";